import { useMemo } from 'react';

import { navigate, routes } from '@redwoodjs/router';
import { MetaTags } from '@redwoodjs/web';

import { NPIDataGrid } from 'src/components/NPIDataGrid/NPIDataGrid';
import { PageContent } from 'src/layouts/MainLayout/PageContent';
import { checkInCallsMocks } from 'src/lib/__mocks__/checkInCalls';

import CheckInCallsGridColDef from './CheckInCallsGridColDef';

const CheckInCallsPage = () => {
    const handleView = ({ id }: { id: number }) => {
        navigate(routes.checkInCallDashboard({ serviceId: id }));
    };

    const tableData = useMemo(() => {
        const result =
            [...checkInCallsMocks]?.map((checkIn) => {
                const { id, merchantName, callName, days } = checkIn;
                return {
                    id,
                    merchantName,
                    callName,
                    days,
                };
            }) ?? [];

        return {
            rows: result,
        };
    }, []);
    return (
        <PageContent heading="Check-In Calls" subHeading="Managing all Service Calls to Merchants">
            <MetaTags title="Check-In Calls" description="Check-In Calls page" />
            <NPIDataGrid
                rows={tableData.rows}
                columns={CheckInCallsGridColDef(handleView)}
                getRowId={(row) => {
                    return row.id;
                }}
                title="Check-in Calls Page"
                dataTestId="check-in-calls-page-table"
            />
        </PageContent>
    );
};

export default CheckInCallsPage;
